import locale from "@bonliva-crm/locale";
import { Box } from "@material-ui/core";
import { Button, WithPopperSimple } from "@bonliva-crm/ui";
import { CreatePresentationMenu } from "./create-presentation-menu";
import { useTenant } from "../../../tenant/tenant";
import { Tenant } from "@bonliva-crm/shared";
import React from "react";

type Props = {
  consultantId: string;
  unfit: boolean;
  onOpenCallListModal: () => void;
  onOpenWorkExperienceModal: () => void;
  onCreateOpportunity: () => void;
  onCreatePresentation: () => void;
  onSendToMedlo: () => void;
  canDuplicateBtns?: React.ReactNode;
};

export function ActionButtons(props: Props) {
  const { tenant } = useTenant();

  return (
    <Box display="flex" alignItems="center" style={{ gap: "1rem" }}>
      <Button
        variant="outlined"
        color="secondary"
        disabled={props.unfit}
        onClick={props.onOpenCallListModal}
      >
        {locale.CallLists}
      </Button>

      <Button
        variant="outlined"
        color="secondary"
        onClick={props.onOpenWorkExperienceModal}
      >
        {locale.workHistory}
      </Button>

      <WithPopperSimple
        popperContent={({ close }) => (
          <CreatePresentationMenu
            onCreateOpportunity={() => {
              props.onCreateOpportunity();
              close();
            }}
            onCreatePresentation={() => {
              props.onCreatePresentation();
              close();
            }}
          />
        )}
      >
        {({ open }) => (
          <Button variant="outlined" color="secondary" onClick={open}>
            {locale.createPresentation}
          </Button>
        )}
      </WithPopperSimple>

      {tenant === Tenant.BonlivaAB && (
        <Button variant="outlined" color="secondary" onClick={props.onSendToMedlo}>
          Skicka till Medlo
        </Button>
      )}

      {props.canDuplicateBtns && props.canDuplicateBtns}
    </Box>
  );
}
